import type { FC } from 'react';
import React from 'react';

import { ContentHeaderPresence } from '@confluence/team-presence/entry-points/ContentHeaderPresence.tsx';
import type { ContentHeaderPresenceProps } from '@confluence/team-presence/entry-points/presenceTypes.ts';

type PresenceProps = {
	contentMode: string | undefined;
	isViewMode?: boolean;
	children?: React.ReactNode;
} & Omit<ContentHeaderPresenceProps, 'analyticSource'>;

export const Presence: FC<PresenceProps> = ({
	collaborators,
	contentId,
	contentType,
	contentMode,
	isViewMode,
	children,
	size,
	maxCount,
	isOverflowSeparated,
}) => {
	return (
		<ContentHeaderPresence
			collaborators={collaborators}
			contentId={contentId}
			contentType={contentType}
			isViewMode={isViewMode}
			size={size}
			maxCount={maxCount}
			isOverflowSeparated={isOverflowSeparated}
			analyticSource={contentMode === 'view' ? 'viewPageScreen' : 'editPageScreen'}
		>
			{children}
		</ContentHeaderPresence>
	);
};
